import { render } from "./CardVictoryPoints.vue?vue&type=template&id=7823b97a&ts=true"
import script from "./CardVictoryPoints.vue?vue&type=script&lang=ts"
export * from "./CardVictoryPoints.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__